import React from 'react';
import BlackListLinkContext from './BlackListLinkContext';

export default function useBlackListLinks() {
  return React.useContext(BlackListLinkContext);
}
